import { Component } from '@angular/core';
import { UserService } from '../../../../../auth-client/services/user.service';
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'brover-add',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.sass'],
    standalone: false
})
export class AddComponent {

  constructor(
    private readonly userService: UserService,
    public dialogRef: MatDialogRef<AddComponent>,
  ) {}

  public form = {
    address: '',
    postalCode: '',
    city: '',
    customerCompanyName: '',
    customerName: ''
  };

  add() {
    this.userService.addCompanyAddress(this.form).subscribe(() => {
      this.dialogRef.close();
    });
  }
}
